import React from 'react';
import Select from '../Select/Select';
import { CLIENT_DOCUMENT_TYPE } from '../../constants';

const SelectClientID = ({ ...props }) => {
  return <Select options={CLIENT_DOCUMENT_TYPE} label={'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectClientID;
